export default options => {
    let fetch = `
const url;
const options;

fetch(url, options)
    .then(response => {
      console.log(response);
    })
    .catch(err => {
      console.error(err);
    });
`

    fetch = fetch.replace(/const url/i, `const url = "${options.url}"`)
    delete options.url
    fetch = fetch.replace(/const options/i, `const options = ${JSON.stringify(options, null, 4)}`)
    return fetch
}
